import React from 'react';
import cx from 'classnames';
import AmiraIconButton, { ICON_BUTTON_TYPES } from '../Global/AmiraIconButton2/AmiraIconButton2';

const DialogPrompt = ({ promptText, showPrompt, showRepeatButton, repeatButtonEnabled, onClickRepeat, assessment }) => (
  <div className={cx('dialogDisplay__prompt', { 'dialogDisplay--invisible': !showPrompt })}>
    <div className="dialogDisplay__repeat">
      <AmiraIconButton
        onClick={onClickRepeat}
        disabled={!repeatButtonEnabled}
        type={ICON_BUTTON_TYPES.REPEAT_AUDIO}
        invisible={!showRepeatButton}
        assessment={assessment}
        secondary
      />
    </div>
    {promptText}
  </div>
);

export default DialogPrompt;
